<template>
    <div class="ext-info">
        <div class="ext-info-biz" v-if="value.hasOwnProperty('kpName')">
            <p><span class="ext-info-biz-text">{{_('KP姓名:')}}</span>{{value.kpName}}</p>
            <p><span class="ext-info-biz-text">{{_('KP电话:')}}</span>{{value.kpPhone}}</p>
            <p><span class="ext-info-biz-text">{{_('门店电话:')}}</span>{{value.phone}}</p>
        </div>
        <template  v-for="(component ,index) in componentsConf">
        <div v-if="checkVisible(component)" :class="`ext-info-component ${component.className}`"  :key="index">
            <div :class="`label ${component.rules && component.rules.required ? 'required' : ''}`">{{component.label}}</div>
            <component
                v-model="value[component.prop]"
                :is="component.is"
                v-bind="component"
                :options="component.prop === 'isNeedPad' ? needPadOption : component.options"
                ></component>
            <!-- <rich-validator v-if="component.prop ==='isNeedPad'" v-model="valid" :model="value[component.prop]" :rules="rules"></rich-validator> -->
        </div>
        </template>
        <rich-button
            v-if="btnText"
            class="ext-info-link-btn"
            :outline="true"
            @click="toLink">{{btnText}}</rich-button>
    </div>
</template>
<script>
import BizTime from './BizTime.vue'
import { i18n } from '@/common/utils/i18n'

export default {
  name: 'ext-info',
  components: {
    BizTime
  },
  data () {
    return {
      valid: '',
      rules: {
        required: true,
        type: 'string',
      }
    }
  },
  props: {
    value: {
        type: Object,
        required: true,
        default () {
            return {}
        }
    },
    link: {
        type: String,
        default: ''
    },
    btnText: {
        type: String,
        default: ''
    },
    componentsConf: {
        type: Array,
        default: () => []
    }
  },
  watch: {
    value: {
      deep: true,
      handler (nVal) {
        this.$emit('input', nVal)
      }
    }
  },
  computed: {
    route () {
        const { shopId } = this.$route.query
        if (this.link === 'sign') {
          return {
            name: 'sign',
            params: {
              id: shopId,
              type: 0
            },
            param: {
              id: shopId,
              type: 0
            },
            query: {
              redirectUrl: 'back'
            }
          }
        }
        return {
          name: this.link,
          query: {
            shopId: shopId,
            redirectUrl: 'back'
          }
        }
    },
    // 改成不可修改
    needPadOption () {
      return [{
        label: i18n.gettext('需要'),
        value: 1,
        disabled: this.value.canUpdateIsNeedPad === 0
      },{
        label: i18n.gettext('不需要'),
        value: 2,
        disabled: this.value.canUpdateIsNeedPad === 0
      }]
}
  },
  mounted () {
  },
  methods: {
    toLink () {
      if (this.link) {
        this.$router.push(this.route)
      }
    },
    checkVisible (component) {
      if (component.checkVisible) {
        return component.checkVisible.call(null, this.value)
      } else {
        return component.visible !== undefined
          ? Boolean(component.visible)
          : true
      }
    }
  }
}
</script>
<style  lang="scss">
.ext-info{
    padding: 0 40px;
    font-size: $fontsize-medium;
    padding-bottom: 10px;
    // padding-left: 40px
    .ext-info-biz {
      color: #666;
      font-size: $fontsize-medium;
      margin-bottom: 10px;
    }
    .ext-info-biz-text {
      display: inline-block;
      width: 150px;
    }
    &-link-btn {
        width: 100%;
        margin: 0 auto;
        // padding: 27px 17px;
        font-size: $fontsize-medium;
        color: #666;
        background: #fcfcfc;
        box-shadow: 0 1px 3Px rgba(0,0,0,.1);
        &::after {
            border: none;
        }
    }
    &-component {
        // width: 450px;
        margin: 0 auto;
        margin-bottom: 15px;
        &.horizontal {
            display: flex;
        }
        &:last-child {
          margin-bottom: 0;
        }
    }
    .label {
        margin-bottom: 10px;
    }
    .rich-radio-group[data-horz=true] {
        display: inline-flex;
        &::after {
            border:none;
        }
        .rich-radio-wrap {
            justify-content: left;
            padding: 0;
        }
        .rich-radio:after {
        border: none;
        }
    }
    .rich-validator {
      .rich-validator-msg {
        position: relative;
        top: 0;
      }
    }
    .required {
      &::before {
        content: "*";
        display: inline-block;
        margin-top: 1px;
        margin-right: .3em;
        color: #e64340;
      }
    }
}
</style>
